import { render, staticRenderFns } from "./AreaSelector.vue?vue&type=template&id=8d47ff8e&scoped=true&"
import script from "./AreaSelector.vue?vue&type=script&lang=js&"
export * from "./AreaSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d47ff8e",
  null
  
)

export default component.exports